const useMobile = () => {
    const isTouch = navigator.maxTouchPoints > 0
    const isMobileAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    if (isMobileAgent) {
        //console.log('User is on a mobile device.')
        // Add mobile-specific logic here
    } else {
        //console.log('User is on a desktop or tablet.')
        // Add desktop-specific logic here
    }
    const isChrome = /Chrome/i.test(navigator.userAgent)
    const isSafari = /Safari/i.test(navigator.userAgent) && !/Chrome/i.test(navigator.userAgent)
    const isFirefox = /Firefox/i.test(navigator.userAgent)
    if (isChrome) {
        //console.log('User is on Chrome.')
    } else if (isSafari) {
        //console.log('User is on Safari.')
    } else if (isFirefox) {
        //console.log('User is on Firefox.')
    } else {
        //console.log('User is on another browser.')
    }
    if (isMobileAgent) {
        if (isChrome) {
            //console.log('User is on a mobile device using Chrome.')
            // Add mobile Chrome-specific logic here
        } else if (isSafari) {
            //console.log('User is on a mobile device using Safari.')
            // Add mobile Safari-specific logic here
        } else {
            //console.log('User is on a mobile device using another browser.')
            // Add generic mobile browser logic here
        }
    } else {
        //console.log('User is on a desktop or tablet.')
        // Add desktop-specific logic here
    }
    const platform = navigator.platform
    if (/Win/i.test(platform)) {
        //console.log('User is on Windows.')
    } else if (/Mac/i.test(platform)) {
        //console.log('User is on macOS.')
    } else if (/Linux/i.test(platform)) {
        //console.log('User is on Linux.')
    } else if (/iPhone|iPad|iPod/i.test(platform)) {
        //console.log('User is on iOS.')
    } else if (/Android/i.test(platform)) {
        //console.log('User is on Android.')
    } else {
        //console.log('User is on an unknown platform.')
    }

    const isSmallScreen = window.matchMedia('(max-width: 600px)').matches

    if (isSmallScreen) {
        //console.log('User is on a small screen (likely a mobile device).')
    } else {
        //console.log('User is on a larger screen (likely a desktop or tablet).')
    }

    const isStandalone = window.matchMedia('(display-mode: standalone)').matches

    if (isStandalone) {
        //console.log('PWA is running in standalone mode.')
    } else {
        //console.log('PWA is running in a browser tab.')
    }
    return isStandalone || isTouch
};

export default useMobile;
